import { resolveValue, type PathValue } from '@intlify/core-base'

import { normalizeKey } from './normalizeKey'

export const resolveI18nMessage = (
  translations: unknown,
  key: string,
  normalizedLicensedTerritory?: string,
): PathValue => {
  const messages = translations as Record<string, PathValue>
  const normalizedKey = normalizeKey(key)

  if (normalizedLicensedTerritory) {
    const territoryMessage = messages[`${normalizedKey}.${normalizedLicensedTerritory}`]
    if (territoryMessage) return territoryMessage
  }

  return messages[normalizedKey] || resolveValue(translations, normalizedKey)
}
